export const FORGOT_PASSWORD_REQUEST='FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS='FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAIL='FORGOT_PASSWORD_FAIL';
export const FORGOT_PASSWORD_RESET_STATE='FORGOT_PASSWORD_RESET_STATE';
export const CLEAR_FORGOT_PASSWORD_ERRORS='CLEAR_FORGOT_PASSWORD_ERRORS'



export const RESET_PASSWORD_REQUEST='RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS='RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL='RESET_PASSWORD_FAIL';
